import { reactive } from 'vue';
import { connectionName, initialState, productsDispatchers, ProductsState, productsStore } from './products.connection';
import { productsSelectors } from './products.selectors';

const productsState = reactive<ProductsState>(initialState as ProductsState);

function subscribe() {
  productsStore.subscribe(connectionName, (state: ProductsState) => {
    Object.assign(productsState, state);
  });
}

if (productsStore) {
  subscribe();
} else {
  // Storybook Workaround
  const init = setInterval(() => {
    if (productsStore) {
      subscribe();
      clearInterval(init);
    }
  }, 200);
}

export const useProductsStore = () => ({
  state: productsState,
  dispatchers: productsDispatchers,
  selectors: productsSelectors,
});
